import React, { Component } from 'react'
import { Card } from '../../components/card'
import { utcToLocalDate } from '../../helpers/timeHelper'
import { User } from '../../core/types'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  resendConfirmationEmail: Callback
  sendResetPasswordEmail: Callback
  user: User
}

export class UserAccount extends Component<Props> {
  static displayName = 'UserAccount'

  render() {
    const { user, resendConfirmationEmail } = this.props
    return (
      <Card title="Account" gridClass="user-account">
        <p className="user-account__start-date">
          Start date: {utcToLocalDate(user.createdAt)}
        </p>
        {user.emailVerified ? (
          <p
            className="user-account__link user-account__link--disabled"
            data-testid="resendConfirmationEmailDisabledLink"
          >
            Resend email verification
          </p>
        ) : (
          <a
            className="user-account__link"
            onClick={() => resendConfirmationEmail(user.id)}
            data-testid="resendConfirmationEmailLink"
          >
            Resend email verification
          </a>
        )}
      </Card>
    )
  }
}

export default UserAccount
